<div [hidden]="noData">
    <span>{{sectiontitle}}</span>
    <div >
        <div #chartElement>
        </div>
    </div>
</div>
